import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 2670. 以前のプロジェクト（費用）削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/prev_purchase_orders/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  id: number;
};
const destroyPrevPurchaseOrder = (props: Props): Promise<any> => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/prev_purchase_orders/${props.id}`
  );
};

export const useDestroyPrevPurchaseOrder = () => {
  return useMutation({
    mutationFn: destroyPrevPurchaseOrder,
  });
};
